import { ModalFooter } from "@hostingbv/lib/src/components/layout/ModalProvider";
import { FC, useState } from "react";
import { config } from "../config";
import { useApiClient } from "@hostingbv/lib/src/api";
import { useRefresh } from "@hostingbv/lib/src/components/RefreshController";
import { Site } from "@hostingbv/lib/src/api/partner/models/Site";
import { Domain } from "@hostingbv/lib/src/api/partner/models/Domain";
import { Server } from "@hostingbv/lib/src/api/partner/models/Server";
import { Input } from "@hostingbv/lib/src/components/form/Input";
import { MailDomain } from "../../../lib/src/api/partner/models/MailDomain";

type AnyEntity = Domain | Site | Server | MailDomain
export const EditNotesModal: FC<{ entity: AnyEntity }> = (props) => {
  const { partnerClient } = useApiClient(config)
  const refresh = useRefresh()

  const [notes, setNotes] = useState(props.entity.notes ?? "")

  const save = async () => {
    await partnerClient.updateNotes(props.entity.id, notes === "" ? null : notes)
    refresh()
  }

  return <>
    <form onSubmit={() => save()} className={""}>
      <Input type={"textarea"} label={"Notes"} value={notes} onChange={setNotes} />
      <ModalFooter text={"Save"} onSubmit={save} />
    </form>
  </>
}
